import { graphqlLink } from 'config/apolloConfig/index';
import { generateBase64, webApp } from '@foxtaibox/foxtailbox-frontend-core';

export type LoginByTelegramWebAppResponse = {
  data?: {
    loginByTelegramWebAppToken: {
      accessToken: string;
      refreshToken: string;
    };
  };
  errors?: { message: string }[];
} | null;

const webAppLogin = async (): Promise<LoginByTelegramWebAppResponse> => {
  const initData = webApp?.initData;
  if (!initData) return null;
  const token = generateBase64(initData);

  const r = await fetch(graphqlLink, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      query: `mutation loginByTelegramWebAppToken {loginByTelegramWebAppToken(token: "${token}") {
                                            accessToken
                                            refreshToken
                                        }}`,
    }),
  });
  return r.json();
};

export default webAppLogin;
